export default __webpack_public_path__ + "static/media/stopButtonHover.649d1652.svg";